import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Button, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core';
import feathersServices from '../../../services/feathersServices';

function CompanyManagementForm(props) {
  const { onClose, onSave, selectedElement, industry, classes, getReports } = props;

  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState('');
  const [active, setActive] = useState(true);
  const [companyInReports, setCompanyInReports] = useState(true);

  useEffect(() => {
    if (selectedElement) {
      getReports({
        query: {
          'companies.companyId': selectedElement._id,
          $limit: 0
        }
      }).then(({ value }) => {
        setCompanyInReports(value.total > 0);
      });
    }
  }, []);

  useEffect(() => {
    if (selectedElement) {
      setTitle(selectedElement.title);
      setDescription(selectedElement.description);
      setActive(selectedElement.active);
    }
  }, [selectedElement]);

  const handleSave = async () => {
    if (selectedElement?._id) {
      await props.saveCompany(selectedElement._id, {
        title,
        description,
        active
      });
    } else {
      await props.createCompany({
        title,
        description,
        active,
        industry: industry._id
      });
    }
    onSave();
    onClose();
  };

  return (
    <>
      <Box className={classes.header} display="flex" alignItems="center" p={2} mb={2}>
        <Typography variant="h5" color="primary">
          {selectedElement?.title || 'Add new company'}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" justifyContent="space-between" p={2} height={1}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField required disabled={true} defaultValue={industry.title} color="secondary" label="Industry" fullWidth variant="outlined" />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              value={title || ''}
              color="secondary"
              label="Company"
              fullWidth
              disabled={selectedElement && companyInReports}
              error={title === ''}
              variant="outlined"
              onChange={({ target }) => setTitle(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={description}
              multiline
              minRows={4}
              maxRows={4}
              color="secondary"
              label="Description"
              fullWidth
              variant="outlined"
              onChange={({ target }) => setDescription(target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              p={1}
              border="1px solid"
              borderColor="grey.400"
              alignItems="center"
              borderRadius="borderRadius"
              className={classes.fieldset}
            >
              <FormControlLabel
                control={<Switch checked={active} onChange={({ target }) => setActive(target.checked)} />}
                labelPlacement="start"
                label="Status"
              />
              &nbsp;&nbsp;
              <Typography component="span">{active ? 'Active' : 'Disabled'}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          &nbsp;
          <Button disabled={!title} onClick={handleSave} color="secondary" variant="outlined">
            {selectedElement ? 'Update' : 'Create'}
          </Button>
        </Grid>
      </Box>
    </>
  );
}

const mapDispatchToProps = {
  getReports: feathersServices.reports.find,
  saveCompany: feathersServices.companies.patch,
  createCompany: feathersServices.companies.create
};

export default connect(null, mapDispatchToProps)(CompanyManagementForm);
